(function () {
    'use strict';
    EO_IntakeFieldController.$inject = ['$scope', '$attrs', '$element', 'FileUtil', 'SelectorDataQuery', 'DateUtil', 'DateUtils'];

    function EO_IntakeFieldController($scope, $attrs, $element, FileUtil, SelectorDataQuery, DateUtil, DateUtils) {
//  
        var $ctrl = this;
        $ctrl.selectableItems = [];
        $ctrl.selectableItemsFilled = false;
        $ctrl.dateValue = '';

        $scope.$watch('$ctrl.field', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });
        $scope.$watch('$ctrl.isEditMode', function (field) {
            if (field) {
                fillSelectableItems();

            }


        });
        $scope.$watch('$ctrl.dateValue', function (val) {
            if (val) {
                var splitedDate = DateUtils.convertToPersianDate(val).date;
                $ctrl.field.value = splitedDate[0]+ "/" + splitedDate[1] + "/" + splitedDate[2];
            }


        });

        function fillSelectableItems() {
            if ($ctrl.isEditMode && !$ctrl.selectableItemsFilled && $ctrl.field.field && $ctrl.field.field.selectorDataTypeId) {
                SelectorDataQuery.findByTypeId($ctrl.field.field.selectorDataTypeId).query(function (data) {

                    if (data) {
                        $ctrl.selectableItems = [];
                        angular.forEach(data, function (item) {
                            $ctrl.selectableItems.push(item.text);
                        })
                        $ctrl.selectableItemsFilled = true;
                    }

                })
            }
        }
        if($ctrl.field.field.fieldType=='Date') {
            $ctrl.dateValue = DateUtil.jalaliToGregorian($ctrl.field.value);
        }

    }


    var EO_IntakeFieldViewer = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/intake-data/eyeson.intake-field.template.html',
        controller: EO_IntakeFieldController,
        bindings: {
            field: '=',
            isEditMode: '<'
        }

    };

    angular
        .module('tikonApp')
        .component('eoIntakeField', EO_IntakeFieldViewer)

})();
